import type { SearchProductsQuery, SearchOffQuery } from '@/types/api';

export const productKeys = {
  all: ['products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  list: (params?: SearchProductsQuery) =>
    [...productKeys.lists(), params?.query ?? '', params?.favoritesOnly ?? false, params?.page ?? 1, params?.limit ?? 20] as const,
  detail: (id: number) => [...productKeys.all, 'detail', id] as const,
  offSearch: (params: SearchOffQuery) =>
    ['off-search', params.query, params.page ?? 1] as const,
};
